export const NETWORK_ACCESS_AUTHORIZED = "access_authorized"
export const NETWORK_ACCESS_NOT_AUTHORIZED = "access_not_authorized"

export const forbiddenNetworkSlugs = ["account_settings", "login"]